<div class="scanner-dialog">
  <div class="scanner-dialog__header">
    <h3>Scan Code</h3>
    <button class="scanner-dialog__close" (click)="cancel()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <!-- Camera viewfinder -->
  <div class="scanner-dialog__camera" *ngIf="cameraActive">
    <video #videoEl autoplay playsinline muted class="scanner-dialog__video"></video>
    <div class="scanner-dialog__overlay">
      <div class="scanner-dialog__crosshair"></div>
    </div>
    <canvas #canvasEl hidden></canvas>
    <p class="scanner-dialog__hint" *ngIf="scanning">Point camera at a barcode or QR code</p>
  </div>

  <!-- Camera error -->
  <div class="scanner-dialog__error" *ngIf="cameraError">
    <i class="material-icons">videocam_off</i>
    <p>{{cameraError}}</p>
  </div>

  <!-- Manual entry fallback -->
  <div class="scanner-dialog__manual">
    <label>Or enter code manually:</label>
    <div class="scanner-dialog__input-row">
      <input type="text" [(ngModel)]="manualCode" placeholder="Enter barcode or promo code..."
             (keydown.enter)="submitManual()" autofocus/>
      <button class="scanner-dialog__submit" (click)="submitManual()" [disabled]="!manualCode?.trim()">
        Go
      </button>
    </div>
  </div>
</div>
